var VV = VV || {};

VV.Popovers = (function() {
	$('html').on('mouseup', function (e) {
		var l = $(e.target);
		if (l[0].className.indexOf('popover') == -1) {
			$('.popover').each(function () {
				$(this).popover('hide');
			});
		}
	});
	$('.poppy').on('click', function (e) {
		return false;
	});
})();